/* eslint-disable */
/* THIS FILE IS AUTOGENERATED, DO NOT EDIT IT! */

import * as Types from '../app/services/types.generated';

import { api } from 'app/services/missionStorageApi';
export type GetActionsQueryVariables = Types.Exact<{
  missionId: Types.Scalars['String']['input'];
}>;


export type GetActionsQuery = { __typename?: 'Query', actions: Array<{ __typename?: 'Action', id: string, missionId: string, actionType: string, sequenceOrder: number, name: string, note: string, args: any, createdAt: any }> };

export type CreateActionMutationVariables = Types.Exact<{
  input: Types.CreateActionInput;
}>;


export type CreateActionMutation = { __typename?: 'Mutation', createAction: { __typename?: 'Action', id: string, missionId: string, actionType: string, sequenceOrder: number, name: string, note: string, args: any, createdAt: any } };

export type UpdateActionMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  input: Types.UpdateActionInput;
}>;


export type UpdateActionMutation = { __typename?: 'Mutation', updateAction: { __typename?: 'Action', id: string, name: string, note: string, args: any } };

export type ReorderActionMutationVariables = Types.Exact<{
  input: Types.ReorderActionInput;
}>;


export type ReorderActionMutation = { __typename?: 'Mutation', reorderAction: { __typename?: 'Action', id: string, sequenceOrder: number } };

export type DeleteActionMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type DeleteActionMutation = { __typename?: 'Mutation', deleteAction: boolean };

export type PrependUndockBeforeLoadMapMutationVariables = Types.Exact<{
  missionId: Types.Scalars['String']['input'];
}>;


export type PrependUndockBeforeLoadMapMutation = { __typename?: 'Mutation', prependUndockBeforeLoadMap?: { __typename?: 'Action', id: string, missionId: string, actionType: string, sequenceOrder: number, name: string, note: string, args: any } | null };


export const GetActionsDocument = `
    query GetActions($missionId: String!) {
  actions(missionId: $missionId) {
    id
    missionId
    actionType
    sequenceOrder
    name
    note
    args
    createdAt
  }
}
    `;
export const CreateActionDocument = `
    mutation CreateAction($input: CreateActionInput!) {
  createAction(input: $input) {
    id
    missionId
    actionType
    sequenceOrder
    name
    note
    args
    createdAt
  }
}
    `;
export const UpdateActionDocument = `
    mutation UpdateAction($id: String!, $input: UpdateActionInput!) {
  updateAction(id: $id, input: $input) {
    id
    name
    note
    args
  }
}
    `;
export const ReorderActionDocument = `
    mutation ReorderAction($input: ReorderActionInput!) {
  reorderAction(input: $input) {
    id
    sequenceOrder
  }
}
    `;
export const DeleteActionDocument = `
    mutation DeleteAction($id: String!) {
  deleteAction(id: $id)
}
    `;
export const PrependUndockBeforeLoadMapDocument = `
    mutation PrependUndockBeforeLoadMap($missionId: String!) {
  prependUndockBeforeLoadMap(missionId: $missionId) {
    id
    missionId
    actionType
    sequenceOrder
    name
    note
    args
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GetActions: build.query<GetActionsQuery, GetActionsQueryVariables>({
      query: (variables) => ({ document: GetActionsDocument, variables })
    }),
    CreateAction: build.mutation<CreateActionMutation, CreateActionMutationVariables>({
      query: (variables) => ({ document: CreateActionDocument, variables })
    }),
    UpdateAction: build.mutation<UpdateActionMutation, UpdateActionMutationVariables>({
      query: (variables) => ({ document: UpdateActionDocument, variables })
    }),
    ReorderAction: build.mutation<ReorderActionMutation, ReorderActionMutationVariables>({
      query: (variables) => ({ document: ReorderActionDocument, variables })
    }),
    DeleteAction: build.mutation<DeleteActionMutation, DeleteActionMutationVariables>({
      query: (variables) => ({ document: DeleteActionDocument, variables })
    }),
    PrependUndockBeforeLoadMap: build.mutation<PrependUndockBeforeLoadMapMutation, PrependUndockBeforeLoadMapMutationVariables>({
      query: (variables) => ({ document: PrependUndockBeforeLoadMapDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetActionsQuery, useLazyGetActionsQuery, useCreateActionMutation, useUpdateActionMutation, useReorderActionMutation, useDeleteActionMutation, usePrependUndockBeforeLoadMapMutation } = injectedRtkApi;

